/**
 * Analytics Event Names
 *
 * All event names used throughout the application.
 * Using constants prevents typos and enables autocomplete.
 */

export const AnalyticsEvents = {
  // ===========================================
  // ACQUISITION & CONVERSION
  // ===========================================
  PLAN_CTA_CLICKED: "plan_cta_clicked",
  PLAN_VIEWED: "plan_viewed",
  CHECKOUT_STARTED: "checkout_started",
  ACCESS_CODE_REDEEMED: "access_code_redeemed",
  // Note: signup_completed and subscription_started are already tracked in auth.ts

  // ===========================================
  // ONBOARDING
  // ===========================================
  ONBOARDING_STARTED: "onboarding_started",
  ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
  ONBOARDING_SKIPPED: "onboarding_skipped",
  ONBOARDING_COMPLETED: "onboarding_completed",
  PROGRAM_SELECTED: "program_selected",

  // ===========================================
  // FITNESS / WORKOUTS
  // ===========================================
  PROGRAM_VIEWED: "program_viewed",
  WORKOUT_DAY_VIEWED: "workout_day_viewed",
  WORKOUT_STARTED: "workout_started",
  EXERCISE_LOGGED: "exercise_logged",
  SUPERSET_LOGGED: "superset_logged",

  // ===========================================
  // PROGRESS TRACKING
  // ===========================================
  PROGRESS_ENTRY_ADDED: "progress_entry_added",
  PROGRESS_ENTRY_UPDATED: "progress_entry_updated",
  PROGRESS_ENTRY_DELETED: "progress_entry_deleted",

  // ===========================================
  // RECIPES
  // ===========================================
  RECIPE_VIEWED: "recipe_viewed",
  RECIPE_FILTER_APPLIED: "recipe_filter_applied",

  // ===========================================
  // COURSES
  // ===========================================
  COURSE_VIEWED: "course_viewed",
  LESSON_STARTED: "lesson_started",
  LESSON_COMPLETED: "lesson_completed",
  LESSON_UNCOMPLETED: "lesson_uncompleted",
  VIDEO_STARTED: "video_started",
  VIDEO_PROGRESS: "video_progress",
  VIDEO_COMPLETED: "video_completed",

  // ===========================================
  // COACH FEEDBACK
  // ===========================================
  FEEDBACK_REQUEST_CREATED: "feedback_request_created",
  FEEDBACK_COMMENT_ADDED: "feedback_comment_added",

  // ===========================================
  // SUPPORT & FEEDBACK
  // ===========================================
  APP_FEEDBACK_SUBMITTED: "app_feedback_submitted",
  PROBLEM_REPORTED: "problem_reported",
  SUPPORT_REQUEST_SENT: "support_request_sent",
} as const;

export type AnalyticsEventName =
  (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];
